export default Object.freeze([
  "Alamo Title Company",
  "Alliant National Title Insurance Company",
  "Chicago Title Insurance Company",
  "Commonwealth Land Title Insurance Company",
  "Doma",
  "Fidelity National Title Insurance Company",
  "First American Title Insurance Company",
  "First National Title Insurance Company",
  "Lawyers Title",
  "Mother Lode Holding Company",
  "North American Title Company",
  "Old Republic National Title Insurance Company",
  "Pioneer Title Company",
  "ServiceLink",
  "Solidifi",
  "Stewart Title Guaranty Company",
  "Title Resource Group",
  "Title Resources Guaranty Company",
  "Westcor Land Title Insurance Company",
  "WFG National Title Insurance Company"
]);
